/**
 * Sticky header powered by Headroom.js
 *
 * Headroom documentation: https://github.com/WickyNilliams/headroom.js
 */
$(window).bind('load', function() {
	/**
	 * Sticky header powered by Headroom.js
	 *
	 * Headroom documentation: https://github.com/WickyNilliams/headroom.js
	 */
	$('.site-header').headroom({
		offset: 60
	});

	if ( $('body').hasClass('single-products') ) {

		var productNavOffset = $('.product-nav').offset();

		$('.product-nav').headroom({
			offset: productNavOffset.top - 77
		});

	}
});